export class SureError extends Error {
  constructor({ code = '', info, message }: SureErrorParam = {}) {
    super(message);
    Object.setPrototypeOf(this, SureError.prototype);
    this.info = info;
    this.code = code;
  }

  code?: string;

  info?: ISureErrorInfo[];

  [key: string]: any;
}

export type StripeError = {
  fields: { [key: string]: string };
};

type SureErrorParam = {
  code?: string;
  info?: ISureErrorInfo[];
  message?: string;
};

export type ISureErrorInfo<Detail = unknown, Field = unknown> = {
  code: string;
  message: string | string[];
  details?: Record<string, Detail>;
  fields?: Record<string, Field>;
};
